export const articles = (state = [], action) => {
  let localState = state;
  switch (action.type) {
    case 'GET_ARTICLES_SUCCESS':
      localState = action.data;
      return localState;
    default:
      return localState;
  }
};


export const articleFavourites = (state = [], action) => {
  let localState = state;
  switch (action.type) {
    case 'GET_ARTICLES_FAVOURITES_SUCCESS':
      localState = action.data;
      return localState;
    default:
      return localState;
  }
};

export default articles;


// WEBPACK FOOTER //
// ./src/Reducers/articles.js